<template>
    <div class="animated fadeIn staticPageInner bgV2 noBackgroundColor p-0 maintenanceProgramPopup">
        <b-form>
            <gofix-table :settings="tableConfig"
                         :table-items="tableItems"
                         @load-items="getTableData"
                         @get-selected="cloneData"
                         ref="gofixTable">
                <template slot="gofix_table:unit_price" slot-scope="data">
                    {{data.item.unit_price | formatMoney}}
                </template>
            </gofix-table>
        </b-form>

        <b-button-group class="d-block text-right">
            <gofix-button label="SUBMIT" @click="sendSelected" :loading="loadings.clone" noBorder></gofix-button>
        </b-button-group>
    </div>
</template>
<script>
    import { filters } from '@/_filterVar.js'
    export default {
        name: 'maintenance-master-clone',
        props:["contractId","contractTermId"],
        data () {
            let filter = JSON.parse(JSON.stringify(filters['sor_master']));
            filter.is_maintenance.value = true;
            filter.is_master.value = true;
            delete filter.contract_id;
            delete filter.contract_term_id;
            return {
                tableConfig:{
                    name: 'clone-maintenance-standard',
                    controls:{
                        reload: false,
                        create: false,
                        delete: false,
                        tableFilter:false,
                        tableImport:false,
                        tableExport:false,
                        tableColumnSettings:false,
                        tablePagination:false,
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "sor_code",
                    sortDirection: "asc",
                    fields: [
                        {
                            key: 'actions',
                            label: '',
                            thClass: 'checkbox-column text-center',
                            tdClass: 'checkbox-column text-center',
                            width: 50,
                            thStyle: "width:50px;",
                            tdStyle: "width:50px;"
                        },
                        {
                            key: 'sor_code',
                            label: 'Code',
                            placeholder: 'search',
                            isActive: 1,
                            isFilter: true,
                            with:120,
                            thStyle: "width:120px",
                            sorting: true,
                        },
                        {
                            key: 'name_service',
                            label: 'Service Cat.',
                            placeholder: 'search',
                            isActive: 1,
                            isFilter: true,
                            with:null,
                            thStyle: "width:auto",
                            sorting: true,
                        },
                        {
                            key: 'equipment_group_name',
                            label: 'Equm.Type',
                            placeholder: 'search',
                            isActive: 1,
                            isFilter: true,
                            with:180,
                            thStyle: "width:180px",
                            sorting: true,
                        },
                        {
                            key: 'recurring_mode',
                            label: 'Freq.',
                            placeholder: 'Select',
                            isActive: 1,
                            isFilter: true,
                            with:100,
                            thStyle: "width:100px",
                            sorting: true,
                        },
                        {
                            key: 'name_checklist_templates',
                            label: 'Checklist temp',
                            placeholder: 'Select',
                            isActive: 1,
                            isFilter: true,
                            with:180,
                            thStyle: "width:180px",
                            sorting: true,
                        },
                        {
                            key: 'standard_reference',
                            label: 'Standard Ref.',
                            placeholder: 'Search',
                            isActive: 1,
                            isFilter: true,
                            with:120,
                            thStyle: "width:120px",
                            sorting: true,
                        },
                    ]
                },
                tableItems: [],
                loadings:{
                    clone: false
                }
            }
        },
        created () {},
        methods:{
            /*-- Table callback --------*/
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("v2SorController/getItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        console.log(err);
                        this.$bvToast.toast("Can not load the maintenance standard", {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: 'danger',
                            solid: true
                        })
                        reject();
                    })
            },
            async cloneData(ids){
                if(!ids.length){
                    this.$bvToast.toast("Please select a item", {
                        title: 'Notification',
                        autoHideDelay: 2000,
                        variant: 'warning',
                        solid: true
                    });
                    return;
                }
                this.loadings.clone = true;
                await this.$store.dispatch("v2SorController/cloneMaster", {
                    ids:ids,
                    contract_id:this.contractId,
                    contract_term_id:this.contractTermId,
                })
                    .then( response => {
                        this.loadings.clone = false;
                        this.$emit("close-modal", true);
                    })
                    .catch(err => {
                        this.$bvToast.toast("Clone failed!", {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: 'danger',
                            solid: true
                        });
                        this.loadings.clone = false;
                    });
            },
            /*---------------*/
            sendSelected(){
                this.$refs.gofixTable.sendSelectedData();
            }
        }
    }
</script>
